<script lang="ts">
  // Quick filter chips (spec §9 item 3): shown while the query is empty or equals one of them;
  // a click toggles the query through `runSearch`.
  import { t, type I18nKey } from '$lib/i18n';
  import { quickFilters } from '$lib/search/grammar';
  import { store } from '$lib/store';

  const chips = $derived(quickFilters(store.user));
  const q = $derived(store.searchQ.trim());
</script>

<div class="fchips">
  {#each chips as c (c.q)}
    <button type="button" class="fchip" class:on={q === c.q} aria-pressed={q === c.q} onclick={() => store.runSearch(c.q)}>{t(c.label as I18nKey)}</button>
  {/each}
</div>

<style>
  /* @css list/QuickChips start */
  .fchips {
    display: flex;
    gap: var(--space-2);
    padding: 0 var(--space-4) var(--space-2);
    flex-wrap: wrap
  }

  .fchip {
    border: 1px solid var(--border-default);
    background: none;
    border-radius: var(--radius-badge);
    padding: var(--space-1) var(--space-3);
    font: inherit;
    font-size: var(--text-xs);
    color: var(--text-body);
    cursor: pointer
  }

  .fchip:hover {
    background: var(--surface-hover)
  }

  .fchip.on {
    background: var(--surface-sunken);
    border-color: var(--text-faint);
    font-weight: 600
  }
  /* @css list/QuickChips end */
</style>
